/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { ICommerceApiSettings } from '@msdyn365-commerce/core';
import { getVariantPriceAsync } from './DataActionExtension.g';
import { ICartLineEntity } from './DataServiceEntities.g';

/**
 * GetVariantPrice Input Action
 */
export class GetVariantPriceInput implements Msdyn365.IActionInput {
    public customer: string;
    public cartLines: ICartLineEntity[];
    private readonly apiSettings: ICommerceApiSettings;
    // TODO: Construct the input needed to run the action
    public constructor(customer: string, cartLines: ICartLineEntity[], apiSettings: ICommerceApiSettings) {
        this.customer = customer;
        this.cartLines = cartLines;
        this.apiSettings = apiSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => generateCacheKey(this.apiSettings, { key: 'customer', value: this.customer });
    public getCacheObjectType = () => 'TODO';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetVariantPriceData {
    cartLines: ICartLineEntity[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createVariantPriceInput = (
    args: Msdyn365.ICreateActionContext<{ customer: string; cartLines: ICartLineEntity[] }>
): Msdyn365.IActionInput => {
    return new GetVariantPriceInput(args.config?.customer || '', args.config?.cartLines || [], args.requestContext.apiSettings);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getVariantPrice(input: GetVariantPriceInput, ctx: Msdyn365.IActionContext): Promise<IGetVariantPriceData> {
    const response = await getVariantPriceAsync({ callerContext: ctx }, input.customer, input.cartLines);
    return { cartLines: response.CartLines! };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetVariantPriceData>>getVariantPrice,
    // TODO: Give your data action a unique id
    id: 'GetVariantPrice',
    input: createVariantPriceInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
